import React from 'react';
import {
  Markup
} from '../components';

export default class Form extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      value: 'Welcom',
      defaultOption: 'lime'
    }
    this.handleSeletcChange = this.handleSelectChange.bind(this); 
    this.handleChange = this.handleChange.bind(this); 
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) { 
    this.setState({value: event.target.value}); 
  }

  handleSelectChange(event) { 
    this.setState({defaultOption: event.target.value}); 
  }

  handleSubmit(event) { 
    event.preventDefault(); 
  }


  render() {
    return ( 
      <form onSubmit={this.handleSubmit}> 
        <Markup>{this.state.value}</Markup>
        <label>
          Name:
        </label> 
        <label> 
          Pick your favorite La Croix flavor: 
        <select value={this.state.defaultOption} onChange={this.handleSelectChange}> 
          <option value="grapefruit">Grapefruit</option> 
          <option value="lime">Lime</option> 
          <option value="coconut">Coconut</option> 
          <option value="mango">Mango</option> 
        </select> 
        </label>
        <br />
        <textarea value={this.state.value} onChange={this.handleChange} /> 
        <input type="submit" value="Submit" /> 
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/components/Form.js